import { render, staticRenderFns } from "./OrderProgress.vue?vue&type=template&id=aa510fd8&scoped=true"
import script from "./OrderProgress.vue?vue&type=script&lang=js"
export * from "./OrderProgress.vue?vue&type=script&lang=js"
import style0 from "./OrderProgress.vue?vue&type=style&index=0&id=aa510fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa510fd8",
  null
  
)

export default component.exports